import React from 'react';
import styles from './ImportInstructions.css';

type ImportInstructionsProps = {
    instructions: React.ReactNode;
    dataTestId: string;
};
const ImportInstructions = ({ instructions, dataTestId }: ImportInstructionsProps) => {
    return (
        <>
            <hr className={styles.divider} />
            <div className={styles.importInstructions} data-testid={dataTestId}>
                {instructions}
            </div>
            <hr className={styles.divider} />
        </>
    );
};

export default ImportInstructions;
